import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getBrowserInfo, GPay_TransactionState } from '@grandvisionhq/payments';
import { useHandleOrderCreation } from './useHandlerOrderCreation.js';
import { useValidateAndSetOrderDetails } from './useValidateAndSetOrderDetails.js';

const useHandleGpayConfig = ({ selectedPaymentMethod , selfUrl , donationInfo , consents , selectedShippingMethod , isSaveDetailsInAccount =false , setIsOrderInProgress ,  })=>{
    const { saveCustomerInformation  } = useValidateAndSetOrderDetails();
    const { handlePlaceOrder  } = useHandleOrderCreation();
    const createGooglePayOrder = React.useCallback((googlePayToken)=>{
        setIsOrderInProgress(true);
        (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type) && handlePlaceOrder({
            selectedPaymentMethod,
            paymentDetails: {
                isValid: true,
                type: selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type,
                data: {
                    googlePayToken,
                    browserInfo: swcHelpers.objectSpread({}, getBrowserInfo())
                }
            },
            selfUrl,
            consents,
            donationInfo,
            isSaveDetailsInAccount,
            setIsOrderInProgress
        });
    }, [
        consents,
        donationInfo,
        handlePlaceOrder,
        isSaveDetailsInAccount,
        selectedPaymentMethod,
        selfUrl,
        setIsOrderInProgress, 
    ]);
    const onGpayAuthorized = React.useCallback((gpay_payment_details)=>{
        createGooglePayOrder(gpay_payment_details.paymentMethodData.tokenizationData.token);
    }, [
        createGooglePayOrder
    ]);
    const handleGpayCtaClick = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(resolve, reject) {
            return yield saveCustomerInformation(selectedShippingMethod, consents).then(({ success  })=>{
                return success ? resolve({
                    transactionState: GPay_TransactionState.SUCCESS
                }) : reject({
                    transactionState: GPay_TransactionState.ERROR
                });
            }).catch(()=>{
                return reject({
                    transactionState: GPay_TransactionState.ERROR
                });
            });
        });
        return function(resolve, reject) {
            return _ref.apply(this, arguments);
        };
    }(), [
        consents,
        saveCustomerInformation,
        selectedShippingMethod
    ]);
    return {
        handleGpayCtaClick,
        onGpayAuthorized
    };
};

export { useHandleGpayConfig };
//# sourceMappingURL=useHandleGpayConfig.js.map
